import { computed, inject } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { firstValueFrom } from 'rxjs';
import { ProductsService } from 'src/app/services/api/products/products.service';
import { withLoadingState } from '../loading-state/with-loading-state';
import { ProductsState } from '../types/products.type';

export const ProductsStore = signalStore(
	{ providedIn: 'root' },
	withState<ProductsState>({
		products: [],
		selectedProductDetails: undefined,
	}),
	withLoadingState({ products: 'init', selectedProductDetails: 'init' }),
	withComputed((state) => ({
		isReader: computed(() => state.selectedProductDetails()?.productType?.id === 2),
	})),
	withMethods((state) => {
		const productsService = inject(ProductsService);
		return {
			fetchProducts: async () => {
				state.loading('products');
				const products = await firstValueFrom(productsService.fetchProducts());
				patchState(state, { products });
				state.loaded('products');
			},
			fetchProduct: async (id: number) => {
				state.loading('selectedProductDetails');
				const selectedProductDetails = await firstValueFrom(
					productsService.fetchProduct(id.toString()),
				);
				patchState(state, { selectedProductDetails });
				state.loaded('selectedProductDetails');
			},
		};
	}),
);
